import {
  LoggerService,
  LOG_LEVEL,
} from '@util/logger.service';
import { environment } from '@env/environment';
import { IFeedback } from '@model/feedback.model';
import { JiraService } from '@api/jira.service';
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-jira-ticket-submittion',
  templateUrl: './jira-ticket-submittion.component.html',
  styleUrls: ['./jira-ticket-submittion.component.scss'],
})
export class JiraTicketSubmittionComponent
  implements OnInit, OnChanges {
  @Input() thingName: string;
  @Input() email: string;
  @Input() firmware: string;
  @Input() productName: string;

  description: string;
  platform: 'iOS' | 'Android' | 'Platform';
  osVersion: string;
  appVersion: string;
  deviceLocale: 'en-US';

  hasSubmitted = false;
  loading = false;
  constructor(private jiraService: JiraService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {}

  fakeSubmit() {
    this.hasSubmitted = true;
  }

  submitFeedback() {
    const feedback: IFeedback = {
      platform: this.platform,
      thingName: this.thingName,
      firmwareVersion: this.firmware || 'unknown',
      timestamp: Date.now(),
      appVersion: this.appVersion || 'Not Reported',
      deviceLocale: this.deviceLocale,
      appStage: environment.env,
      product: this.productName,
      screen: 'Submitted Through Customer Care',
      comment: this.description,
      osVersion: this.osVersion || 'Not Reported',
      email: this.email,
    };
    this.loading = true;
    this.jiraService.submitFeedback(feedback).subscribe(
      (data) => {
        this.hasSubmitted = true;
        this.loading = false;
      },
      (error) => {
        LoggerService.log(error, LOG_LEVEL.ERROR);
        this.loading = false;
      },
    );
  }

  validate(): boolean {
    if (
      this.platform &&
      this.osVersion &&
      this.deviceLocale &&
      this.description
    ) {
      if (this.hasSubmitted) {
        return !false;
      } else {
        return !true;
      }
    }
    return !false;
  }

  reset() {
    this.description = '';
    this.platform = 'Android';
    this.osVersion = '';
    this.appVersion = '';
    this.deviceLocale = 'en-US';
    this.hasSubmitted = false;
  }
}
